import React from 'react';
import { Link } from 'react-router-dom';
import './PromoBanner.css';
import defaultBgImg from '../../assets/Home/Hero1.png';

const PromoBanner = ({
  title = "Ready to Move Your Production with Confidence?",
  subtitle = "Partner with DEXA Innovation for safe, compliant, and reliable industrial machinery and high-precision CNC equipment across India, backed by four decades of operational excellence.",
  buttonText = "Get a Quote",
  buttonLink = "/contact",
  bgImage = defaultBgImg
}) => {
  return (
    <section className="promo-banner-section">
      <div 
        className="promo-banner-container"
        style={{
          backgroundImage: `linear-gradient(90deg, rgba(15, 17, 21, 0.94) 0%, rgba(18, 20, 26, 0.82) 55%, rgba(15, 17, 21, 0.65) 100%), url(${bgImage})`
        }}
      >
        {/* Content Box */}
        <div className="promo-content-box">
          <h2 className="promo-title">
            {title}
          </h2>
          <p className="promo-subtitle">
            {subtitle}
          </p>

          <Link to={buttonLink} className="promo-cta-btn">
            <span className="promo-btn-text">{buttonText}</span>
            <div className="promo-btn-icon-wrapper">
              <svg 
                className="promo-btn-arrow" 
                width="16" 
                height="16" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="2.5" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              >
                <line x1="7" y1="17" x2="17" y2="7"></line>
                <polyline points="7 7 17 7 17 17"></polyline>
              </svg>
            </div>
          </Link>
        </div>

      </div>
    </section>
  );
};

export default PromoBanner;


